import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { mapToServiceRequest } from '~/modules/resourcing/common/util';
import { useMeContext } from '~/modules/me';
import { ResourceMatchesStatus, ResourceRequestStatus } from '~/types';
import { getSourceMetadata } from '../../hooks/useMarkToBeHiredResourceRequestWithHiringRequestedSubStatus';
import { SUBMIT_RESOURCE_REQUEST } from './withMarkResourceRequestAsSubmitted';

const useMarkResourceRequestAsSubmitted = ({
  resourceRequest,
  isPtiEnabled,
  cacheUpdateFunctions
}) => {
  const [markResourceRequestAsSubmitted] = useMutation(SUBMIT_RESOURCE_REQUEST);
  const {
    featureFlags: { isPsaPraaResourceMatchingEnabled }
  } = useMeContext();

  const onMarkResourceRequestAsSubmitted = useCallback(
    () =>
      markResourceRequestAsSubmitted(
        mapToServiceRequest({
          request: resourceRequest,
          responseType: 'markResourceRequestAsSubmitted2',
          responseTypeName: 'MarkResourceRequestAsSubmittedResult',
          requestStatus: ResourceRequestStatus.Submitted,
          resourceMatchesStatus: ResourceMatchesStatus.InProgress,
          isPsaPraaResourceMatchingEnabled,
          sourceMetadata: getSourceMetadata({
            isPtiEnabled,
            resourceRequest
          }),
          cacheUpdateFunctions,
          isPtiEnabled
        })
      ),
    [
      cacheUpdateFunctions,
      isPtiEnabled,
      isPsaPraaResourceMatchingEnabled,
      markResourceRequestAsSubmitted,
      resourceRequest
    ]
  );

  return {
    onMarkResourceRequestAsSubmitted
  };
};

export default useMarkResourceRequestAsSubmitted;
